module.exports = __webpack_public_path__ + "static/img/coin_b.ff7b7474.png";